package io.jsonize.web.components

import androidx.compose.foundation.background
import androidx.compose.foundation.gestures.Orientation
import androidx.compose.foundation.gestures.draggable
import androidx.compose.foundation.gestures.rememberDraggableState
import androidx.compose.foundation.layout.*
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.*
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.compose.ui.input.pointer.PointerInputScope
import androidx.compose.ui.Alignment

@Composable
fun SplitPane(
    modifier: Modifier = Modifier,
    left: @Composable BoxScope.() -> Unit,
    right: @Composable BoxScope.() -> Unit
) {
    var dividerWeight by remember { mutableStateOf(0.6f) }

    Row(modifier = modifier.fillMaxSize()) {
        Box(modifier = Modifier.weight(dividerWeight).fillMaxHeight()) {
            left()
        }

        // draggable divider
        Box(
            modifier = Modifier
                .width(6.dp)
                .fillMaxHeight()
                .background(MaterialTheme.colorScheme.primary)
                .draggable(
                    orientation = Orientation.Horizontal,
                    state = rememberDraggableState { delta ->
                        // small heuristic to update weight
                        dividerWeight = (dividerWeight + delta / 1000f).coerceIn(0.2f, 0.8f)
                    }
                )
        )

        Box(modifier = Modifier.weight(1f - dividerWeight).fillMaxHeight()) {
            right()
        }
    }
}
